export default {
    namespaced: true,
    state:{
        title: null,
        url: null,
        state : null,
        contents : null,
        paramDatas: null,
        focusItem : null,
        isCallbackFunc: false,
        isBackDrop: false
    },
    getters:{
    },
    mutations:{
        setContents:(state, payload) => {
            state.title = null;
            state.url = null;
            state.state = null;
            state.contents = null;
            state.paramDatas = null;
            state.focusItem = null;
            state.isCallbackFunc = false;
            state.isBackDrop = false;

            if(payload.title){
                state.title = payload.title;
            }

            if(payload.url){
                state.url = payload.url;
            }

            if(payload.state){
                state.state = payload.state;
            }

            if(payload.contents){
                state.contents = payload.contents;
            }

            if(payload.paramDatas){
                state.paramDatas = payload.paramDatas;
            }

            if(payload.isCallbackFunc){
                state.isCallbackFunc = payload.isCallbackFunc;
            }

            if(payload.isBackDrop){
                state.isBackDrop = payload.isBackDrop;
            }

            if(payload.focusItem){
                state.focusItem = payload.focusItem;
            }
        }
    },
    actions: {
        setContents:( { commit } , payload ) => {
            commit('setContents', payload);
        }
    }
}